import React from 'react';
import PropTypes from 'prop-types';

/**
 * Wrapper component to ensure proper ARIA parent-child relationships in grid
 * This wrapper adds the proper role="row" element around gridcells
 */
const AccessibleGridCellWrapper = ({
  children,
  rowIndex,
  style,
  className,
}) => {
  // The original cell renderer will create a div with role="gridcell" or "columnheader"
  // We need to wrap it in a div with role="row"
  return (
    <div
      role="row"
      aria-rowindex={rowIndex + 1}
      style={style}
      className={className}
      data-test-id={`row-${rowIndex}`}
    >
      {children}
    </div>
  );
};

AccessibleGridCellWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  rowIndex: PropTypes.number.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default AccessibleGridCellWrapper;
